import React, { useState, useContext, useRef, useEffect } from 'react';
import { GdkMultipleSelectBox } from "@gdk/multiple-select-box";
import $ from 'jquery';
import { searchAgencies } from "../../api/search";
import { updateSweepDetails } from '../../api/agency-profile';
import EnrollForm from './EnrollForm';
import ExpandableFormList from "../gdk/ExpandableForm/ExpandableFormList";
import ExpandableFormListItem from "../gdk/ExpandableForm/ExpandableFormListItem";
import AgencyProfileForm from './AgencyProfileForm.js';
import Pagination from './Pagination.js';
import '../../styles/Sweeps.css';
import { set } from 'react-hook-form';
import '@gdk/to-top-arrow/dist/styles/gdk-to-top-arrow.css'; // Import the CSS for styling
import { GdkToTopArrow } from '@gdk/to-top-arrow'; // Import the component

export default function SweepsBranchManagement({ agencyProfile, toggleUpdate, agencyBranches, setAgencyBranches }) {
    const [agencyProfileExpandableForm, setAgencyProfileExpandableForm] = useState();
    const [selectedAgencyBranchIds, setSelectedAgencyBranchIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [viewAll, setViewAll] = useState(false);
    const branchesPerPage = 10;

    const onAgencyBranchSelectBoxChange = (event) => {
        const selectedBranchId = Array.from(event.target.selectedOptions, option => option.value);
        setSelectedAgencyBranchIds(selectedBranchId);

        //total pages after filtering and adjust currentpage
        const newTotalPages = Math.ceil(selectedBranchId.length / branchesPerPage);
        setCurrentPage(prevPage => (prevPage > newTotalPages ? newTotalPages || 1 : prevPage));
    };

    const [isFormVisible, setIsFormVisisble] = useState(false);

    const handleEnrollClick = () => {
        setIsFormVisisble(true);
    };

    useEffect(() => {
        new GdkMultipleSelectBox({
            "content": "#agency-branch-select",
            "initialOptions": {
                placeholder: "Select Branch"
            }
        });

        $("#agency-branch-select").on("select2:select select2:unselect", onAgencyBranchSelectBoxChange);

        return () => {
            // Clean up the event listener on component unmount
            $("#agency-branch-select").off("select2:select select2:unselect", onAgencyBranchSelectBoxChange);
        };
    }, []);

    useEffect(() => { $("#agency-branch-select").trigger("change") });

    useEffect(() => {
        agencyProfileExpandableForm?.closeExpandedForm(document.getElementById("agencies-branch-form-li"));
    }, [selectedAgencyBranchIds, currentPage]);

    //Get paginated branches list 
    const getDisplayedBranches = () => {
        let displayedBranches = [];
        if (selectedAgencyBranchIds.length > 0) {
            displayedBranches = selectedAgencyBranchIds.map(id => agencyBranches.find(branch => branch.agencyId === id));
        } else {
            displayedBranches = [...agencyBranches]
        }
        return viewAll ? displayedBranches : displayedBranches.slice((currentPage - 1) * branchesPerPage, currentPage * branchesPerPage);
    };

    useEffect(() => {
        const toTopArrowElement = document.getElementById("to-top-arrow-id");

        if (toTopArrowElement) {
            try {
                toTopArrowElement.classList.add("to-top-arrow");

                const toTopArrow = new GdkToTopArrow({
                    content: "#to-top-arrow-id",
                    toTopArrowClicked: function () {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    },
                });
                console.log("GdkToTopArrow initialized successfully.");
            } catch (error) {
                console.error("Error initializing GdkToTopArrow:", error);
            }
        } else {
            console.error("Element with ID 'to-top-arrow-id' not found.");
        }
    }, []);

    const totalPages = selectedAgencyBranchIds.length > 0
        ? Math.ceil(selectedAgencyBranchIds.length / branchesPerPage)
        : Math.ceil(agencyBranches.length / branchesPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setViewAll(false);
    };

    const handleViewAll = () => {
        setViewAll(!viewAll);
    };

    //Get the branch status for chip value
    const getBranchStatus = (branch) => {

        if ((branch?.sweepDetails?.SweepsPaymentMethodId ?? null) !== null) {
            return "Active Not Default";
        }
        else if (branch?.sweepDetails?.IsPrincipleDeactivated || agencyProfile?.sweepDetails?.IsPrincipleDeactivated || !agencyProfile?.sweepDetails?.IsSweepsEnrolled) {
            return "INActive";
        }
        else {
            return "Active";
        }
    }

    return (
        <div className='sweeps'>
            <div hidden={!(agencyBranches?.length > 0)}>
                <div className="form-field">
                    <label htmlFor="agency-branch-select" className="text">Select an Agency Branch</label>
                    <div>
                        <select multiple id="agency-branch-select" onChange={onAgencyBranchSelectBoxChange} disabled={!agencyBranches}>
                            {agencyBranches
                                ?.sort((a, b) => a.name?.localeCompare(b.name))
                                ?.map(branch =>
                                    <option value={branch?.agencyId} key={branch?.agencyId}>
                                        {`${branch?.agencyId}`}
                                    </option>
                                )
                            }
                        </select>
                    </div>
                    <div>
                        <h3 className="header-padding">Branches<gds-tooltip>By default, all branches use the same sweep account as their agency. However, you can add or remove a new sweep account exclusive to a branch. </gds-tooltip></h3>
                        {getDisplayedBranches().map(branch =>
                            <ExpandableFormList setExpandableForm={setAgencyProfileExpandableForm} key={`${branch?.agencyId}-${toggleUpdate}`}>
                                <ExpandableFormListItem
                                    id="agencies-branch-form-li"
                                    headline={`${branch?.name} - ${branch?.agencyId}`}
                                    editable={true}
                                    branchStatusChip={getBranchStatus(branch)}
                                    form={<AgencyProfileForm
                                        expandableForm={agencyProfileExpandableForm}
                                        agencyProfile={branch}
                                        setAgencyBranches={setAgencyBranches}
                                        principalAgencyProfile={agencyProfile}
                                    />}
                                />
                            </ExpandableFormList>
                        )}
                    </div>
                </div>
                {totalPages > 1 && (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative' }}>
                        <Pagination
                            totalPages={totalPages}
                            handlePageChange={handlePageChange}
                            currentPage={currentPage}
                            handleViewAll={handleViewAll}
                            viewAll={viewAll}
                        />
                    </div>
                )}
                <div
                    id="to-top-arrow-id"
                    className="to-top-arrow"
                    style={{
                        position: 'fixed',
                        right: '1rem',
                        bottom: '1rem',
                        zIndex: 35,
                    }}
                >
                </div>
            </div>
        </div>
    );
}